import { render, staticRenderFns } from "./UpdateTaLp.vue?vue&type=template&id=6dd3ec0c&scoped=true"
import script from "./UpdateTaLp.vue?vue&type=script&lang=js"
export * from "./UpdateTaLp.vue?vue&type=script&lang=js"
import style0 from "./UpdateTaLp.vue?vue&type=style&index=0&id=6dd3ec0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3ec0c",
  null
  
)

export default component.exports